package org.moxultimate.topwithmox.wallpaper.data

import kotlinx.serialization.Serializable

/**
 * WallpaperTagsEntity
 * Response DTO for GET /wallpaper-tag.
 * Maps to the Spring WallpaperTagsEntity returned by the tag lookup table.
 */
@Serializable
data class WallpaperTagsEntity(
    val id: Long = 0,
    val tag: String,
)
